import { Box, SxProps } from "@mui/material";
import Image from "mui-image";

// ----------------------------------------------------------------------

type Props = {
	url: string;
	sx?: SxProps;
	width?: number;
};

export default function LanguageImage({ url, sx }: Props) {
	return (
		<Box
			component='span'
			sx={{
				lineHeight: 0,
				display: "block",
				overflow: "hidden",
				"& .wrapper": {
					width: 1,
					height: 1,
					backgroundSize: "cover !important"
				},
				...sx
			}}
		>
			<Image
				bgColor={undefined}
				duration={500}
				fit={"cover"}
				src={url}
				style={{
					backgroundColor: "background.neutral",
					zIndex: 100
				}}
			/>
		</Box>
	);
}
